import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { usePlayer } from '../../../PlayerContext';
import PlayButton from './PlayButton';
import platform, { OS_TYPES } from '../../../../player/utils/platform';

function Play({ isLarge, isMini }) {
  const player = usePlayer();
  const { isPlayingAds, playing, chromecastEnabled } = useSelector(({ playback }) => ({
    isPlayingAds: playback.isPlayingAds,
    playing: playback.playing,
    chromecastEnabled: playback.chromecastEnabled,
  }));

  const isBetweenAds = !chromecastEnabled && isPlayingAds && (
    player.adsPlayerElement?.readyState === HTMLMediaElement.HAVE_NOTHING || player.adsPlayerElement?.ended
  );

  const isMobile = [OS_TYPES.IOS, OS_TYPES.ANDROID].includes(platform.os);

  const icon = playing || isBetweenAds ? (
    <g fill="white">
      <rect width="35%" height="90%" rx="3px" y="5%" />
      <rect width="35%" height="90%" rx="3px" x="65%" y="5%" />
    </g>
  ) : (
    <path
      d="M0.814453 2.80805V25.8019C0.814453 27.5553 2.69691 28.6206 4.14662 27.6662L21.7595 16.1693C23.1011 15.3037
      23.1011 13.3062 21.7595 12.4184L4.14662 0.943683C2.69691 -0.0106934 0.814453 1.05466 0.814453 2.80805Z"
      fill="white"
    />
  );

  return (
    <PlayButton
      onClick={() => player.togglePlay()}
      viewBox="0 0 23 29"
      isLarge={isLarge}
      isMini={isMini}
      isMobile={isMobile}
    >
      {icon}
    </PlayButton>
  );
}

Play.propTypes = {
  isLarge: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default React.memo(Play);
